"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBLicensePlatePositive = function SvgBLicensePlatePositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M135.212 77.332H8.43A8.43 8.43 0 010 68.902V8.43A8.43 8.43 0 018.43 0h33.463a2.107 2.107 0 110 4.215H8.43a4.215 4.215 0 00-4.214 4.214v60.41a4.215 4.215 0 004.214 4.215h126.783a4.215 4.215 0 004.215-4.215V32.031a2.107 2.107 0 114.215 0v36.857a8.43 8.43 0 01-8.43 8.444z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M91.732 4.215h-39.87a2.107 2.107 0 110-4.215h39.87a2.107 2.107 0 110 4.215z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M141.556 24.08H11.843a2.107 2.107 0 110-4.215h127.605V8.429a4.215 4.215 0 00-4.214-4.214h-33.52a2.107 2.107 0 010-4.215h33.498a8.43 8.43 0 018.43 8.43v13.542c0 1.156-.93 2.096-2.086 2.108z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M81.883 14.21h-20.18a2.107 2.107 0 110-4.214h20.18a2.107 2.107 0 110 4.214zM11.977 60.67a2.24 2.24 0 01-.668-.106 2.107 2.107 0 01-1.334-2.669l6.666-19.963a2.107 2.107 0 011.995-1.44 2.107 2.107 0 011.995 1.405l6.764 19.991a2.107 2.107 0 11-3.99 1.349l-4.727-14.05-4.671 14.05a2.107 2.107 0 01-2.03 1.433z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M21.846 57.34h-6.322a2.107 2.107 0 010-4.215h6.322a2.107 2.107 0 010 4.215zM39.632 60.62h-4.98a2.107 2.107 0 01-2.108-2.107V38.634c0-1.164.943-2.107 2.107-2.107h3.983a7.074 7.074 0 015.486 11.54 7.08 7.08 0 01-4.488 12.553zm-2.873-4.214h2.873a2.866 2.866 0 000-5.732h-2.873v5.732zm0-9.947h1.875a2.859 2.859 0 000-5.718H36.76v5.718zM58.885 60.67a7.116 7.116 0 01-7.108-7.102v-9.932A7.109 7.109 0 0165.6 41.317a2.112 2.112 0 01-3.983 1.405 2.894 2.894 0 00-5.62.949v9.897a2.894 2.894 0 005.62.976 2.107 2.107 0 113.969 1.405 7.116 7.116 0 01-6.702 4.72zM108.878 60.67a7.109 7.109 0 01-6.687-4.707 2.107 2.107 0 113.962-1.405 2.894 2.894 0 102.725-3.884 2.107 2.107 0 010-4.215 7.109 7.109 0 110 14.21z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M108.878 50.674a2.107 2.107 0 010-4.215 2.894 2.894 0 10-2.725-3.87 2.107 2.107 0 01-3.962-1.405 7.109 7.109 0 116.687 9.49zM76.44 60.67a2.107 2.107 0 01-2.108-2.108V43.657l-1.447 1.447a2.107 2.107 0 01-2.978-2.958l5.043-5.043a2.107 2.107 0 013.597 1.489v19.97a2.107 2.107 0 01-2.108 2.108zM96.459 60.768h-9.926a2.107 2.107 0 01-1.685-3.372l8.885-11.829c.175-.214.322-.45.436-.702a2.81 2.81 0 00.183-1.019v-.218a2.894 2.894 0 10-5.781 0 2.107 2.107 0 11-4.215 0 7.109 7.109 0 1114.21 0v.218a7.06 7.06 0 01-.45 2.5 7.214 7.214 0 01-1.018 1.785l-6.322 8.43h5.711a2.107 2.107 0 110 4.214l-.028-.007zM131.553 57.34h-9.996a2.107 2.107 0 01-2.065-2.55l3.512-16.57a2.115 2.115 0 114.137.885l-2.97 14.049h7.396a2.107 2.107 0 010 4.214l-.014-.028z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M131.553 60.67a2.107 2.107 0 01-2.108-2.108v-9.981a2.107 2.107 0 114.215 0v9.981a2.107 2.107 0 01-2.107 2.108z",
    fill: "#1B7"
  })));
};

var _default = SvgBLicensePlatePositive;
exports["default"] = _default;